<template>
  <div class="form-group row">
    <div class="col-11 row">
      <div class="col-sm-2 text-sm-right">
        <label>Número Reserva:</label>
      </div>
      <div class="col-md-4 col-sm-10 mb-3">
        <the-mask :mask="['##/######/####']" type="text" class="form-control" v-model="filtroProtocolo.idReservaProtocolo"/>
      </div>

      <div class="col-sm-2 text-sm-right">
        <label v-if="checkPermissionReservar()">Tipo Protocolo</label>
      </div>
      <div class="col-md-4 col-sm-10 mb-3">
        <div class="form-check form-check-inline" v-if="checkPermissionReservar()">
          <label class="mr-1" v-for="(item) in tiposProtocolo" :key="item.key">
            <input type="radio"
              class="form-check-input"
              :value="item.key"
              :checked="filtroProtocolo.tipoProtocolo == item.key"
              v-model="filtroProtocolo.tipoProtocolo">
            {{ item.value }}
          </label>
        </div>
      </div>
    </div>

    <div class="col-11 row">
    <div class="col-sm-2 text-sm-right">
      <label>Motivo:</label>
    </div>
    <div class="col-sm-10 mb-3">
      <input type="text" class="form-control" v-model="filtroProtocolo.motivoReserva">
    </div>
    </div>

    <div class="col-12 row btnAcoes">
      <div class="col-1"></div>
      <button class="btn btn-outline-success" @click.prevent="pesquisar"> Pesquisar </button>
      <button class="btn btn-outline-danger" @click.prevent="limpar"> Limpar </button>
    </div>
  </div>
</template>

<script>
import ReservaProtocoloService from '@/services/ReservaProtocoloService'
import eventBus from '@/uteis/eventBus'

import { componentIsVisible, rules, INVALID } from '@/uteis/action/permissao'

export default {
  name: 'filtroPesquisaReservados',

  props: {
    rowsNumber: { required: true, type: Number },
    eventBusDataName: { required: true, type: String },
    eventBusPaginationName: { required: true, type: String }
  },

  data () {
    return {
      filtroProtocolo: {
        idReservaProtocolo: '',
        motivoReserva: '',
        tipoProtocolo: '',
        offset: 1,
        range: this.rowsNumber,
        idDepartamento: ''
      },
      tiposProtocolo: [{
        value: 'Documento Avulso',
        key: 'DOCUMENTO_AVULSO'
      }, {
        value: 'Processo',
        key: 'PROCESSO'
      }]
    }
  },

  created () {
    eventBus.$on(this.eventBusPaginationName, (numeroPagina) => {
      this.trocaDePagina(numeroPagina)
    })

    this.service = new ReservaProtocoloService()
    this.pesquisar()
  },

  methods: {
    pesquisar () {
      const dadosSessao = this.$store.getters.getDadosSessao
      this.filtroProtocolo.idDepartamento = dadosSessao.sessao.idDepartamento
      if (this.checkPermissionReservar() === INVALID) {
        this.filtroProtocolo.tipoProtocolo = 'DOCUMENTO_AVULSO'
      }

      this.service.buscarReservasProtocolo(this.filtroProtocolo).then(res => {
        eventBus.$emit(this.eventBusDataName, res)
      }).catch(err => {
        console.log(err)
      })
    },

    limpar () {
      this.filtroProtocolo.idReservaProtocolo = ''
      this.filtroProtocolo.motivoReserva = ''
      this.filtroProtocolo.tipoProtocolo = ''
      this.pesquisar()
    },

    trocaDePagina (numeroPagina) {
      this.filtroProtocolo.offset = numeroPagina
      this.pesquisar()
    },

    checkPermissionReservar () {
      const { VISUALIZAR_PROTOCOLO_RESERVADO_TIPO_PROCESSO } = rules
      return componentIsVisible(VISUALIZAR_PROTOCOLO_RESERVADO_TIPO_PROCESSO)
    }
  },

  destroyed () {
    eventBus.$off(this.eventBusPaginationName)
  }
}
</script>

<style scoped lang="scss">

.row {
  margin-top: 2px;
}
</style>
